<div class="data-cards-view">
    <div class="data-cards-view__content" #content>
        @if (isInitialLoading()) {
            <div class="data-cards-view__initial-skeletons" [style.--data-card-columns]="columns()">
                @for (item of skeletonItems(); track item) {
                    <div>
                        <ngx-skeleton-loader
                            class="cipo--width--full"
                            [theme]="{
                                height: skeletonHeight() + 'px',
                                margin: 0,
                                display: 'flex',
                                'border-radius': '8px',
                            }" />
                    </div>
                }
            </div>
        } @else if (!cards().length) {
            <div class="m-t-xl">
                <cipo-not-found />
            </div>
        } @else {
            <cdk-virtual-scroll-viewport
                cipoKeyboardList
                class="data-cards-view__viewport"
                role="list"
                [ariaLabel]="'a11y.dataList.list' | translate"
                [itemCount]="virtualRows().length"
                [itemSize]="virtualRowHeight()"
                [minBufferPx]="virtualRowHeight() * 10"
                [maxBufferPx]="virtualRowHeight() * 11"
                [style.--data-card-row-height]="virtualRowHeight() + 'px'"
                (scrolledIndexChange)="onScrollIndexChange()"
                data-testid="data-cards-view">
                <div
                    *cdkVirtualFor="let virtualRow of virtualRows(); let index = index; trackBy: trackByVirtualRow"
                    class="data-card-virtual-row"
                    role="listitem"
                    [style.--data-card-columns]="columns()"
                    [attr.data-list-index]="index"
                    tabindex="0">
                    @for (card of virtualRow.cards; track card.entity_instance_id) {
                        <div class="data-card-virtual-item">
                            <div class="gridItem">
                                <app-data-card-view
                                    data-testid="datalist-card"
                                    [card]="card"
                                    [actions]="actions()"
                                    (click)="cardClickInternal(card)" />
                            </div>
                        </div>
                    }
                    @if (virtualRow.showSkeleton) {
                        <div
                            class="data-card-virtual-item"
                            aria-hidden="true"
                            data-testid="data-cards-view-next-page-skeleton">
                            <div class="gridItem">
                                <ngx-skeleton-loader
                                    class="cipo--width--full"
                                    [theme]="{
                                        height: cardGridHeight() + 'px',
                                        margin: 0,
                                        display: 'flex',
                                        'border-radius': '8px',
                                    }" />
                            </div>
                        </div>
                    }
                </div>
            </cdk-virtual-scroll-viewport>
        }
    </div>
    <div class="data-cards-view__footer">
        @if (infiniteScroll() && loadedRowsCount() && !loading()) {
            <p class="cipo--text--end m-r-xl" data-testid="data-cards-view-items-loaded">
                {{
                    "general.table.itemsLoaded"
                        | translate: { loaded: loadedRowsCount(), total: options().pagination?.length ?? 0 }
                }}
            </p>
        }
        @if (options().pagination && !infiniteScroll()) {
            @let serverPagination = serverPaginate();
            @if (serverPagination) {
                <div class="data-cards-view__pagination cipo-text--medium-sm cipo-bg--white">
                    @if (
                        cards()?.length && !options().hidePagesLoaded && !isLoading() && serverPagination.pagesCount > 0
                    ) {
                        <p
                            class="data-cards-view__page-loaded cipo-text--medium-sm p-r cipo--border-right--solid"
                            data-testid="paged-datalist-page-loaded">
                            {{
                                "general.table.pageLoaded"
                                    | translate
                                        : {
                                              page: serverPagination.pageIndex + 1,
                                              total: serverPagination.pagesCount,
                                          }
                            }}
                        </p>
                    }
                    <mat-paginator
                        #serverPaginator
                        data-testid="datalist-paginator datalist-paginator-server"
                        showFirstLastButtons
                        [style]="{ display: !cards().length && !loading() ? 'none' : 'block' }"
                        [pageIndex]="serverPagination.pageIndex"
                        [pageSize]="serverPagination.pageSize"
                        [pageSizeOptions]="serverPagination.pageSizeOptions"
                        [length]="serverPagination.length"
                        [disabled]="loading()"
                        (page)="paginationChange($event)" />
                </div>
            } @else {
                <mat-paginator
                    data-testid="datalist-paginator datalist-paginator-client"
                    [style]="{ display: !cards().length && !loading() ? 'none' : 'block' }" />
            }
        }
    </div>
</div>
